module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-18-4cd3d7f5f10b449408eb253183e32b2b.svg";